import { useTranslation } from 'react-i18next';

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogTitle,
} from '@codes/ui-kit/components/ui/alert-dialog';

import { useDialogStore } from '../../stores';

export const WorkspacePendingDialog = () => {
    const { t } = useTranslation();

    const { isWorkspacePendingDialogOpen, setWorkspacePendingDialog } = useDialogStore();

    return (
        <AlertDialog open={isWorkspacePendingDialogOpen} onOpenChange={setWorkspacePendingDialog}>
            <AlertDialogContent>
                <AlertDialogTitle>{t('project.create.workspacePendingMessageTitle')}</AlertDialogTitle>
                <AlertDialogDescription className="text-center text-sub-title mt-2">
                    {t('project.create.workspacePendingMessageDesc')}
                </AlertDialogDescription>
                <AlertDialogFooter>
                    <AlertDialogAction>{t('confirm')}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
